<template>
  <v-card  :class="{ 'cardheight': $vuetify.breakpoint.mdAndUp }" flat>
    <v-container v-if="isReady">
      <v-layout row class="mb-1">
        <v-flex xs12>
          <span
            class="font-weight-bold grey--text text--darken-1 title text-lowercase"
            id="titleBooking"
          >
            {{ title }}
          </span>
        </v-flex>
      </v-layout>
      <v-divider
        class="secondary mb-5 mt-2"
        style="border-width: 3px"
      ></v-divider>

      <v-layout row wrap>
        <v-flex xs12 sm7>
          <v-layout row wrap>
            <v-layout row wrap>
              <v-flex xs12 class="ml-4 mb-2">
                <span
                  class="body-1 mr-2 grey--text text--darken-1"
                  v-html="$t('global.id')"
                  >:</span
                >

                <span class="body-2" v-if="booking.externalId">
                  {{ booking.externalId }}
                </span>
                <span class="body-2" v-else>
                  {{ booking.id }}
                </span>
              </v-flex>
            </v-layout>

            <v-flex xs12 class="ml-4 mb-2">
              <span
                v-if="this.booking.isFacility"
                class="body-1 mr-2 grey--text text--darken-1"
                v-html="$t('global.placeholder.start')"
                >:</span
              >
              <span
                v-else
                class="body-1 mr-2 grey--text text--darken-1"
                v-html="$t('global.placeholder.from')"
                >:</span
              >
              <span class="body-2">
                {{ booking.startLocal | formatDateAsUtc }}
              </span>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="showEnd">
            <v-flex xs12 class="ml-4 mb-2">
              <span
                class="body-1 mr-2 grey--text text--darken-1"
                v-html="$t('global.placeholder.to')"
                >:</span
              >

              <span class="body-2">
                {{ booking.endLocal | formatDateAsUtc }}
              </span>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="booking.plate">
            <v-flex xs12 class="ml-4 mb-2">
              <span
                class="body-1 mr-2 grey--text text--darken-1"
                v-html="$t('global.plate')"
                >:</span
              >

              <span class="body-2">
                {{ booking.plate }}
              </span>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="hasAssignation">
            <v-flex xs12 class="ml-4 mb-2">
              <span
                class="body-1 mr-2 grey--text text--darken-1"
                v-html="$t('reservation.detail.spotAssigned')"
                >:</span
              >

              <span class="body-2">
                {{ booking.spotName }}
              </span>
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="showMaxAvailability">
            <v-flex xs12 class="ml-4 mb-2">
              <span
                class="body-1 mr-2 grey--text text--darken-1"
                v-html="$t('global.max.availability')"
                >:</span
              >

              <span class="body-2">
                {{ booking.maxAvailabilityLocal | formatDateAsUtc }}
              </span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex
          xs12
          sm5
          class="text-xs-right display-2 warning--text font-weight-bold"
        >
          {{ bookingPrice }}
        </v-flex>
      </v-layout>
      <slot></slot>
    </v-container>
  </v-card>
</template>

<script>
import moment from 'moment';
import { setTimeout } from 'timers';

export default {
  name: 'BookingShow',
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isModifiable() {
      return !(
        this.isSubscription ||
        this.booking.status === 'PAID' ||
        this.booking.status === 'IN_USE' ||
        this.booking.isFacility
      );
    },
    title() {
      if (typeof this.booking.status === 'undefined') {
        return '';
      }
      let status = this.$i18n.t(`status.BOOKING_${this.booking.status}`);
      if (this.booking.isFacility) {
        return this.$i18n.t('facility.detail.status.title');
      } else if (this.isSubscription) {
        status = this.$i18n.t(`status.SUBSCRIPTION_${this.booking.status}`);
        return this.$i18n.t('subscription.detail.status.title', {
          status: status,
        });
      }
      return this.$i18n.t('reservation.detail.status.title', {
        status: status,
      });
    },
    showMaxAvailability() {
      if (this.isSubscription) {
        return false;
      }

      if (this.booking.maxAvailabilityLocal === 'undefined') {
        return false;
      }

      return moment(this.booking.endLocal)
        .utc()
        .add(1, 'day')
        .isAfter(this.booking.maxAvailabilityLocal);
    },
    showEnd() {
      return (
        (this.isSubscription || this.booking.status === 'PAID') &&
        !this.booking.isFacility
      );
    },
    isSubscription() {
      return this.booking.type === 'SUBSCRIPTION';
    },
    bookingPrice() {
      if (this.isSubscription || this.booking.status === 'PAID') {
        return this.booking.price;
      } else {
        return this.booking.hourPriceWithCurrency;
      }
    },
    isAPR() {
      return this.booking.isAPR;
    },
    hasAssignation() {
      return this.booking.hasSpotAssignation;
    },
  },
  data() {
    return {
      isReady: false,
    };
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      self.isReady = true;
    }, 250);
  },
};
</script>

<style lang="scss" scoped>
#titleBooking {
  display: inline-block;
}
#titleBooking::first-letter {
  text-transform: uppercase !important;
}
.cardheight {
  height: 100%;
}
</style>
